module.exports = __webpack_public_path__ + "static/overview-e49fedb34035ac15cc236ce0de758b1b.png";